import { ConfigResponse } from '@zoom/appssdk'
import { create } from 'zustand'

export interface AuthStore {
  context: ConfigResponse | null // zoomSDK context
  authContext: string | null // encrypted string context for backend verification
  isVerifiedZoom: boolean
  inMeeting: boolean
}

export const useAuthStore = create<AuthStore>(() => ({
  context: null,
  authContext: null,

  isVerifiedZoom: false,
  inMeeting: false,
}))
